module.exports = __webpack_public_path__ + "img/oplimit.1d82cd28.png";